<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
        <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                    <v-flex xs6>
                      <cal-picker v-model="form.tranDateFrom" :label="labels.tranDateFrom" v-validate="fromDateValidation(form.tranDateTo)" :data-vv-as="labels.tranDateFrom" data-vv-name="tranDateFrom" :error-messages="errors.collect('tranDateFrom')" :min="fromDateMinDate" :max="fromDateMax()"></cal-picker>
                    </v-flex>
                    <v-flex xs6>
                      <cal-picker v-model="form.tranDateTo" :label="labels.tranDateTo" v-validate="toDateValidation(form.tranDateFrom)" :data-vv-as="labels.tranDateTo" data-vv-name="tranDateTo" :error-messages="errors.collect('tranDateTo')" :min="form.tranDateFrom" :max="fromDateMax()"></cal-picker>
                    </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </v-flex>
        <v-flex xs12 class="pt-3">
          <v-checkbox :label="labels.pbPrtParam" v-model="form.pbPrtParam" :error-messages="errors.collect('pbPrtParam')"
              data-vv-name="pbPrtParam" :data-vv-as="labels.pbPrtParam" />
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>
<script>
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import { checkDateRangeFrom, checkDateRangeTo } from '@/directives/common'
export default {
  mixins: [
    commonAjaxMixin,
    MessageMixin
  ],
  data() {
    return {
      menu: {},
      submitting: false,
      form: {
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        pbPrtParam: true,
        format: 'PDF'
      },
      labels: {
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        pbPrtParam: 'Print Runtime Parameters',
        export: 'Export To',
        reportType: 'Report Type'
      },
      fromDateMinDate: new Date(2000, 0, 1),
      supportedFormat: [],
      panel1: [0],
      panel2: [0]
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            if (reportFormat[format].value === 'PDF') {
              result.push(reportFormat[format])
            }
          }
        })
      }
      return result
    },
    doValidateToTranDate() {
      if (this.form.tranDateFrom !== 0) {
        return '|valMaxTranDateFrom:' + this.form.tranDateFrom
      } else {
        return ''
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.$store.state.reports.claimReports.menu.userApprovalList
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
        this.loading = false
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    },
    fromDateMax() {
      return new Date(2070, 11, 31)
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  }
}
</script>
